import { CircleButton } from 'component/Button/CircleButton'
import { Space } from 'component/Space'
import { Spinner } from 'component/Spinner'
import { Vertical } from 'component/Vertical'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { store } from 'store/store'
import css from './Doc.module.scss'

export const Doc = observer(() => {
  const { doc } = store
  const [ready, setReady] = useState(false)

  useBodyScrollLock(true)

  const onLoad = useLatestCallback(() => {
    setReady(true)
  })

  const onClose = useLatestCallback(() => {
    store.doc = ''
  })

  return <Vertical className={css.doc}>
    <iframe className={css.frame} src={doc} onLoad={onLoad} />
    {!ready && <Space className={css.load}>
      <Spinner />
    </Space>}
    <Space pin={[16, 16, null, null]}>
      <CircleButton size={64} action={onClose}>
        <Icon size={32} name="close" />
      </CircleButton>
    </Space>
  </Vertical>
})
